<template>
  <div>
    <div v-for="(change, index) in row.changes" :key="index" class="mb-4">
      <p class="name">{{change.name}}</p>
      <div class="space-x-4 mt-4 d-flex">
        <p class="old-change">{{change.old}}</p>
        <p class="new-change">{{change.new}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangeHistoryLegal",
  props: ['row'],
};
</script>

<style lang="scss" scoped>

p {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #78909C;
  margin-bottom: 0;
  width: fit-content;
}

.old-change {
  color: #FFFFFF;
  background-color: #B0BEC5;
  border-radius: 8px;
  padding: 3px 12px;
  text-decoration: line-through;
}

.new-change {
  color: #263238;
  background-color: #ECECFF;
  border-radius: 8px;
  padding: 3px 12px;
}

.name {
  color: #FFFFFF;
  background-color:  #5D5FEF;
  border-radius: 8px;
  padding: 3px 12px;
}

.space-x-4 {
  p:not(:first-child) {
    margin-left: 12px;
  }
}
</style>